import React, { Component } from "react";
import LinkButton from "../../components/LinkButton";
import Button from "../../components/Button";
import { connect } from "react-redux";
import { applyVerifyEmailActionCode, sendVerificationEmail } from "../../actions/userActions";
import { Loader } from "semantic-ui-react";
import "./index.css";

class EmailVerifiedPage extends Component {
  constructor(props) {
    super(props);
    this.props.actions.applyVerifyEmailActionCode();
  }
  render() {
    const { isPending, isVerifed } = this.props;
    return (
      <div className="email-verifed page">
        {isPending ? (
          <Loader size="large" active inline="centered" />
        ) : isVerifed ? (
          <div className="message">
            <div className="title">Your email has been verified</div>
            <LinkButton href="/" value="Go to Home" />
          </div>
        ) : (
          <div className="message">
            <div className="title">Sorry this link has expired</div>
            <div className="buttons">
              <div className="button-wrapper">
                <LinkButton href="/" value="Go to Home" />
              </div>
              <div className="button-wrapper">
                <Button value="Resend confirmation" onClick={this.props.actions.sendVerificationEmail} />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isPending: state.ui.isVerificationPending,
  isVerifed: state.ui.isVerificationCodeVerified,
});
const mapDispatchToProps = dispatch => ({
  actions: {
    applyVerifyEmailActionCode: actionCode => dispatch(applyVerifyEmailActionCode(actionCode)),
    sendVerificationEmail: () => dispatch(sendVerificationEmail()),
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerifiedPage);



// WEBPACK FOOTER //
// ./src/scenes/EmailVerifiedPage/index.js